﻿import moment from 'moment';

// Function to format date as 'DD.MM.YYYY'
const formatDateLV = (date) => {
    return moment(date).format('DD.MM.YYYY');
};

// Function to format time as 'HH:mm:ss'
const formatTimeLV = (date) => {
    return moment(date).format('HH:mm:ss');
};

// Function to combine formatted date and time as 'DD.MM.YYYY HH:mm:ss'
const formatDateTimeLV = (date) => {
    return moment(date).format('DD.MM.YYYY HH:mm:ss');
};

// Function to get the current date in 'DD.MM.YYYY' format
const getCurrentDateLV = () => {
    return moment().format('DD.MM.YYYY');
};

// Function to get the current day of the month
const getCurrentDay = () => {
    return moment().date();
};


const formatDateForData = (dateString) => {
    if (!dateString) return '';
    const [year, month, day] = dateString.split('-');
    return `${month}.${day}.${year}`;
}

function getMonthNameFromDate(dateString) {
    const [day, month, year] = dateString.split('.');

    const date = new Date(year, month - 1, day);

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    return monthNames[date.getMonth()];
}

export { formatDateLV, formatTimeLV, getCurrentDateLV, getCurrentDay, formatDateTimeLV, formatDateForData, getMonthNameFromDate };